import { render, staticRenderFns } from "./ListarCancela.vue?vue&type=template&id=08233769"
import script from "./ListarCancela.vue?vue&type=script&lang=js"
export * from "./ListarCancela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports